import '../style/Home.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import myDetails from "../assets/myDetails.json";
import Footer from '../components/Footer';
import my_photo from '../assets/photo.jpg'
import my_logo from '../assets/logo.png'

function Home() {

    const handleMailClick = () => {
        navigator.clipboard.writeText(myDetails?.socials?.email)
            .then(() => {
                toast.success('Mail ID copied to your Clipboard', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            })
            .catch((err) => {
                console.error('Failed to copy email address: ', err);
                toast('Failed to copy email address');
            });
    };

    const handleDiscordClick = () => {
        navigator.clipboard.writeText(myDetails?.socials?.discord_id)
            .then(() => {
                toast.success('Discord User ID copied to your Clipboard', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            })
            .catch((err) => {
                console.error('Failed to copy discord id: ', err);
                toast('Failed to copy discord id');
            });
    };

    let navigate = useNavigate();

    const goToBio = useCallback(() => {
        navigate('/home/bio');
    }, [navigate]);
    const goToSkills = useCallback(() => {
        navigate('/home/skills');
    }, [navigate]);
    const goToProjects = useCallback(() => {
        navigate('/home/projects');
    }, [navigate]);
    const goToExperience = useCallback(() => {
        navigate('/home/experience');
    }, [navigate]);
    const goToEducation = useCallback(() => {
        navigate('/home/education');
    }, [navigate]);

    return (
        <div className="home-main">
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />
            <ToastContainer />
            <div className="home">
                <div className="new-tab-console pop-up">
                    <div className="tab-bar">
                        <div className="tab-name">
                            <img id='my-logo' src={my_logo} alt='' />
                            <div id='tab-title'>Indirakanth's Terminal</div>
                        </div>
                        <div className="tab-options">
                            <img className='tab-icon' src="https://img.icons8.com/fluency-systems-filled/96/FFFFFF/compress--v1.png" alt='' />
                            <img className='tab-icon' src="https://img.icons8.com/fluency-systems-filled/96/FFFFFF/full-screen.png" alt='' />
                            <img className='tab-icon' src="https://img.icons8.com/fluency-systems-filled/96/FFFFFF/delete-sign.png" alt='' />
                        </div>
                    </div>
                    <div className="console-content">
                        <div className="prompt">stormsalpha:\&gt; cat intro.txt</div>
                        <div className="content" style={{ marginTop: 4 }}>
                            {myDetails.summary[0][1]}
                        </div>
                        <div className="divider">{"-".repeat(Math.floor(window.innerWidth / 16))}</div>
                        <div className="prompt">stormsalpha:\&gt; find / -name "resume.pdf"</div>
                        <div className='content nav-bar-menu'>
                            <a href={myDetails["resume_link"]} target="_blank" rel="noopener noreferrer" className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/resume.png" alt='' />
                                <span>open-resume-pdf</span>
                            </a>
                        </div>
                        <div className="divider">{"-".repeat(Math.floor(window.innerWidth / 16))}</div>
                        <div className="prompt">stormsalpha:\&gt; unzip links.zip</div>
                        <div className='content nav-bar-menu'>
                            <div className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/gmail-new.png" alt='' onClick={handleMailClick} />
                                <span>email</span>
                            </div>
                            <a href={myDetails.socials.linkedin} target="_blank" rel="noopener noreferrer" className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/linkedin.png" alt='' />
                                <span>linkedin</span>
                            </a>
                            <a href={myDetails.socials.github} target="_blank" rel="noopener noreferrer" className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/github.png" alt='' />
                                <span>github</span>
                            </a>
                            <a href={myDetails.socials.behance} target="_blank" rel="noopener noreferrer" className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/behance.png" alt='' />
                                <span>behance</span>
                            </a>
                            <a href={myDetails.socials.leetcode} target="_blank" rel="noopener noreferrer" className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/external-tal-revivo-bold-tal-revivo/100/e8e8e8/external-level-up-your-coding-skills-and-quickly-land-a-job-logo-bold-tal-revivo.png" alt='' />
                                <span>leetcode</span>
                            </a>
                            <div className='nav-bar-items sm-cnt-btn sm-link-btn'>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/discord--v1.png" alt='' onClick={handleDiscordClick} />
                                <span>discord</span>
                            </div>
                        </div>
                        <div className="divider">{"-".repeat(Math.floor(window.innerWidth / 16))}</div>
                        <div className="prompt">stormsalpha:\&gt; ls</div>
                        <div className='content nav-bar-menu'>
                            <div className="nav-bar-items sm-cnt-btn sm-link-btn" onClick={goToExperience}>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/briefcase-settings.png" alt="briefcase-settings" />
                                <span>experience</span>
                            </div>
                            <div className="nav-bar-items sm-cnt-btn sm-link-btn" onClick={goToSkills}>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/development-skill.png" alt="development-skill" />
                                <span>skills</span>
                            </div>
                            <div className="nav-bar-items sm-cnt-btn sm-link-btn" onClick={goToProjects}>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/project.png" alt="briefcase-settings" />
                                <span>projects-and-work</span>
                            </div>
                            <div className="nav-bar-items sm-cnt-btn sm-link-btn" onClick={goToEducation}>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/school.png" alt="briefcase-settings" />
                                <span>education</span>
                            </div>
                            <div className="nav-bar-items sm-cnt-btn sm-link-btn" onClick={goToBio}>
                                <img className='link-icon' src="https://img.icons8.com/ios-filled/100/e8e8e8/resume.png" alt="briefcase-settings" />
                                <span>bio</span>
                            </div>
                        </div>
                        <div className="divider">{"-".repeat(Math.floor(window.innerWidth / 16))}</div>
                    </div>
                </div>
                <div className="image-container pop-up">
                    <img id='my-photo' src={my_photo} alt='' />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Home;
